import { defineComponent as _defineComponent } from 'vue'
import WsButton from '@WS_Components/WsButton.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RemoveBtn',
  props: {
  label: {type: Boolean},
  textColor: { type: String, default: 'ws-error' },
},
  setup(__props) {

const props = __props;



return { __sfc: true,props, WsButton }
}

})